<template>
  <v-sheet color="transparent" :width="width">
    <v-text-field
      v-model="price"
      @input="(v) => (price = formatPrice(v))"
      class="price-field"
      background-color="transparent"
      hide-details
      dense
      solo
      flat
      tile
    ></v-text-field>
  </v-sheet>
</template>

<script>
const formatPrice = function (str, float = false) {
  let price = 0;
  if (str) price = str.replace(/\D/g, "");

  price = (parseFloat(price) / 100).toFixed(2);

  if (float) return price;

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(price);
};

export default {
  props: {
    value: {
      type: [Number, String],
      default: "",
    },
  },
  data() {
    return {
      price: "",
    };
  },
  created() {
    if (this.value !== "Sob Consulta" && this.value > 0)
      this.price = formatPrice(this.value);
  },
  computed: {
    width() {
      return 62 + (this.price.length - 7) * 9;
    },
  },
  methods: {
    formatPrice,
  },
  watch: {
    value() {
      if (this.value !== "Sob Consulta" && this.value > 0)
        this.price = formatPrice(this.value);
    },
    price() {
      this.$emit("set-value", formatPrice(this.price, true));
    },
  },
};
</script>

<style lang="scss" scoped>
.price-field::v-deep {
  .v-input__slot {
    font-size: 0.875rem;
    padding: 0 !important;
  }
}
</style>
